module.exports = __webpack_public_path__ + "img/img_record_process.26c72404.png";